const fetch = require("node-fetch");

function createAuthorizationHeader(token) {
  return { Authorization: `Bearer ${token}` };
}

async function login(id, password) {
  const reqBody = JSON.stringify({
    username: id,
    password: password,
  });

  let request = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: reqBody,
  };

  return fetch("/api/login", request).then((response) => response);
}

async function logout(token) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch("/api/logout", request).then((response) => {
    return Promise.resolve(response.ok);
  });
}

async function getAllFarms(token) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch("/api/farms", request).then((response) => response.json());
}

async function getFarm(token, id) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/farm/${id}`, request).then((response) => response.json());
}

async function getEnduser(token, id) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/enduser/${id}`, request).then((response) =>
    response.json()
  );
}

async function getEnduserStats(token, id) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/enduser_stats/${id}`, request).then((response) =>
    response.json()
  );
}

async function getEnduserScheduleState(token, id, scheduleId) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/enduser_schedule_state/${id}/${scheduleId}`, request).then(
    (response) => response.json()
  );
}

async function setUnitMetadata(token, metadata) {
  const reqBody = JSON.stringify(metadata);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/unit/${metadata.unit_mac}`, request).then((response) =>
    response.text()
  );
}

async function deleteUnit(token, mac) {
  let request = {
    method: "DELETE",
    headers: Object.assign(createAuthorizationHeader(token)),
  };

  return fetch(`/api/unit/${mac}`, request).then((response) => response.text());
}

async function swapUnits(token, unit_macs) {
  const reqBody = JSON.stringify(unit_macs);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/unit_swap/${unit_macs.mac_out}`, request).then(
    (response) => response.text()
  );
}

async function getSchedules(token, farmId) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/schedules/${farmId}`, request).then((response) =>
    response.json()
  );
}

async function getScheduleGroups(token, scheduleId) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/schedule_groups/${scheduleId}`, request).then((response) =>
    response.json()
  );
}

async function saveSchedule(token, schedule) {
  const reqBody = JSON.stringify(schedule);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/schedule`, request).then((response) => response.text());
}

async function setActiveSchedule(token, farm) {
  const reqBody = JSON.stringify(farm);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/farm/schedule_active`, request).then((response) =>
    response.text()
  );
}

async function deployEnduserSchedule(token, schedule) {
  const reqBody = JSON.stringify(schedule);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/farm/schedule_deploy`, request).then((response) =>
    response.json()
  );
}

async function deleteSchedule(token, id) {
  let request = {
    method: "DELETE",
    headers: Object.assign(createAuthorizationHeader(token)),
  };

  return fetch(`/api/schedule/${id}`, request).then((response) =>
    response.text()
  );
}

async function saveScheduleGroup(token, group) {
  const reqBody = JSON.stringify(group);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/schedule_group`, request).then((response) =>
    response.text()
  );
}

async function saveScheduleGroupUnits(token, scheduleGroupUnits) {
  const reqBody = JSON.stringify(scheduleGroupUnits);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/schedule_group_units`, request).then((response) =>
    response.text()
  );
}

async function deleteScheduleGroupUnits(token, scheduleGroupUnits) {
  const reqBody = JSON.stringify(scheduleGroupUnits);

  let request = {
    method: "DELETE",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/schedule_group_units`, request).then((response) =>
    response.text()
  );
}

async function getScheduleGroupUnits(token, scheduleId) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/schedule_group_units/${scheduleId}`, request).then(
    (response) => response.json()
  );
}

async function deleteScheduleGroup(token, id) {
  let request = {
    method: "DELETE",
    headers: Object.assign(createAuthorizationHeader(token)),
  };

  return fetch(`/api/schedule_group/${id}`, request).then((response) =>
    response.text()
  );
}

async function saveGroup(token, group) {
  const reqBody = JSON.stringify(group);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/group`, request).then((response) => response.text());
}

async function getGroups(token, farmId, groupType) {
  let request = {
    method: "GET",
    headers: createAuthorizationHeader(token),
  };

  return fetch(`/api/farm/${farmId}/group/${groupType}`, request).then(
    (response) => response.json()
  );
}

async function deleteGroup(token, id) {
  let request = {
    method: "DELETE",
    headers: Object.assign(createAuthorizationHeader(token)),
  };

  return fetch(`/api/group/${id}`, request).then((response) => response.text());
}

async function saveGroupUnits(token, groupUnits) {
  const reqBody = JSON.stringify(groupUnits);

  let request = {
    method: "PUT",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      createAuthorizationHeader(token)
    ),
    body: reqBody,
  };

  return fetch(`/api/group_units`, request).then((response) => response.text());
}

export {
  login,
  logout,
  getAllFarms,
  getFarm,
  getEnduser,
  getEnduserStats,
  getEnduserScheduleState,
  setUnitMetadata,
  deleteUnit,
  swapUnits,
  getSchedules,
  getScheduleGroups,
  saveSchedule,
  setActiveSchedule,
  deployEnduserSchedule,
  saveScheduleGroup,
  saveScheduleGroupUnits,
  deleteScheduleGroupUnits,
  getScheduleGroupUnits,
  deleteScheduleGroup,
  deleteSchedule,
  getGroups,
  saveGroup,
  deleteGroup,
  saveGroupUnits,
};
